<template>
  <div>
    <section>
      <v-card
        flat>
        <v-card-text 
          class="pt-3 body-1 line-text-second"
          :style="form.status === 'TIDAK DIPROSES' ? 'height: 700px; overflow-y: auto;' : ''">
          <ValidationObserver ref="form">
            <v-form class="text-left">
              <ValidationProvider 
                name="layanan_kode" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Jenis Produk
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-select
                  style="max-width: 50%;"
                  outlined
                  dense
                  color="#ff64ad"
                  placeholder="Contoh. KTP-EL"
                  
                  :items="list.service"
                  item-text="layanan_nama"
                  item-value="layanan_kode"
                  item-color="#ff64ad"

                  hide-details

                  v-model="form.layanan_kode"
                  :success="form.layanan_kode.length > 0 && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Jenis Produk {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.layanan_kode.length > 0 && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <div
                class="my-6">
                <ValidationProvider 
                  name="nomor" 
                  rules="required" 
                  v-slot="{ errors, valid }">
                  <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                    <!-- Nomor (KK/NIK/DLL) -->
                    Nomor Identitas
                    <span class="error--text">
                      (wajib diisi)
                    </span>
                  </div>

                  <v-text-field
                    style="max-width: 70%;"
                    dense
                    outlined
                    color="#ff64ad"
                    hide-details
                    placeholder="Contoh. 33100062XXXXXXX"
                    v-model="form.nomor"
                    v-uppercase
                    :success="form.nomor !== '' && valid"
                    :error-messages="errors">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Nomor {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="form.nomor !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </div>

              <div
                class="my-6">
                <ValidationProvider 
                  name="nama" 
                  rules="required" 
                  v-slot="{ errors, valid }">
                  <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                    <!-- Nama (Nama Kepala Keluarga/Nama Lengkap/DLL) -->
                    Nama Identitas Produk
                    <span class="error--text">
                      (wajib diisi)
                    </span>
                  </div>

                  <v-text-field
                    style="max-width: 70%;"
                    dense
                    outlined
                    color="#ff64ad"
                    hide-details
                    placeholder="Contoh. Fabdulrafi"
                    v-model="form.nama"
                    v-uppercase
                    :success="form.nama !== '' && valid"
                    :error-messages="errors">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Nama {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="form.nama !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </div>

              <ValidationProvider 
                name="status" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Status
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-select
                  style="max-width: 60%;"
                  outlined
                  dense
                  color="#ff64ad"
                  :placeholder="form.layanan_kode === 'KTP' ? 'Contoh. SIAP DICETAK' : 'Contoh. DIAJUKAN TTE'"
                        
                  :items="form.layanan_kode === 'KTP' ?
                    [
                      'BELUM DIVERIFIKASI',
                      'SIAP DICETAK',
                      'SUDAH DICETAK',
                      'SIAP DIAMBIL',
                      'TIDAK DIPROSES'
                    ] :
                    form.layanan_kode === 'SKT' ?
                    [
                      'BELUM DIVERIFIKASI',
                      'BELUM DIAJUKAN TTE',
                      'DIAJUKAN TTE',
                      'TIDAK DIPROSES'
                    ] :
                    form.layanan_kode === 'KK' ?
                    [
                      'BELUM DIVERIFIKASI',
                      'BELUM DIAJUKAN TTE',
                      'DIAJUKAN TTE',
                      'TIDAK DIPROSES'
                    ] :
                    form.layanan_kode === 'KIA' ?
                    [
                      'BELUM DIVERIFIKASI',
                      'BELUM DIAJUKAN TTE',
                      'DIAJUKAN TTE',
                      'SIAP DICETAK',
                      'SUDAH DICETAK',
                      'SIAP DIAMBIL',
                      'SUDAH DIAMBIL',
                      'TIDAK DIPROSES'
                    ] :
                    [
                      'BELUM DIVERIFIKASI',
                      'BELUM DIAJUKAN TTE',
                      'DIAJUKAN TTE'
                    ]"
                  item-color="#ff64ad"

                  hide-details

                  v-model="form.status"
                  :success="form.status.length > 0 && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Status {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.status.length > 0 && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <div v-if="form.status === 'TIDAK DIPROSES'"
                class="mt-6">
                <div class="body-2 mb-2">
                  Keterangan
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>

                <quill-editor 
                  ref="myTextEditor"
                  :options="{
                    placeholder: 'Contoh. Alasan kenapa tidak diproses'
                  }"
                  v-model="form.note">
                </quill-editor>
              </div>

              <v-alert 
                type="error" 
                text dense prominent 
                class="mt-6"
                v-show="message.error.length > 0">
                {{  message.error }}
              </v-alert>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-2"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#ff64ad"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="$emit('close', false); reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </section>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    props: {
      detail: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        list: {
          service: [],
          status: []
        },
        form: {
          id: '',
          ajuan_id: '',
          nomor: '',
          layanan_kode: '',
          nama: '',
          status: '',
          note: ''
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchService()
        this.fetchStatus()

        this.reset()
      },
      async fetchService () {
        // let params = {
        //   limit: 10000,
        //   order_by: 'ASC',
        //   list_type: 'short',
        //   auth_role: 1
        // }

        // await get('layanan', { params })
        // .then(response => {
        //   let res = response.data

        //   if (res.code === 200) {
        //     this.list.service = res.data
        //   }
        // })

        // let params = {
        //   limit: 10000,
        //   order_by: 'ASC',
        //   list_type: 'short',
        //   auth_role: 1
        // }

        // this.list.service = []

        // await get('layanan', { params })
        // .then(response => {
        //   let res = response.data

        //   if (res.code === 200) {
        //     res.data.map((obj, index) => {
        //       if (index < 6) this.list.service.push(obj)
        //     })
        //   }
        // })

        let params = {
          limit: 10000,
          order_by: 'ASC',
          list_type: 'short',
          auth_role: 1
        }

        this.list.service = []

        await get('layanan/produk', { params })
        .then(response => {
          let res = response.data

          if (res.code === 200) {
            this.list.service = res.data
            
            // res.data.map((obj, index) => {
            //   if (index < 6 || index > 8) this.list.service.push(obj)
            // })
          }
        })
      },
      async fetchStatus () {
        // let params = {
        //   limit: 10000
        // }

        // await get('master/status_produk', { params })
        // .then(response => {
        //   let res = response.data

        //   if (res.code === 200) {
        //     this.list.status = res.data
        //   }
        // })

        this.list.status = [
          'BELUM DIVERIFIKASI',
          'BELUM DIAJUKAN TTE',
          'DIAJUKAN TTE',
          'SIAP DICETAK',
          'SUDAH DICETAK',
          'SIAP DIAMBIL',
          'TIDAK DIPROSES'
        ]
      },
      reset () {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: '',
          ajuan_id: this.detail.ajuan_id,
          nomor: '',
          layanan_kode: '',
          nama: '',
          status: '',
          note: ''
        }

        this.process.form = false
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {

          this.process.form = true

          console.log(this.form)

          // SAVE TO REST API
          await post(`admin/produk/${this.form.layanan_kode}/create`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            if (res.code === 200) {
              this.reset()

              this.$emit('close', false)

              this.$emit('product', 2)
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>